<div class="brand-header">
  <ng-container *ngIf="data.logo">
    <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
  </ng-container>
  <div class="brand-details">
    <h1>{{ data.companyName | camelcase}}</h1>
    <ng-container *ngIf="data.url">
      <a class="data-url" (click)="sanitizeUrl(data.url); $event.preventDefault();"
      rel="noopener noreferrer"
       >{{ data.url }}</a>
    </ng-container>
  </div>
  <div>
    <div class="share-links">

      <div class="social-media-links">
        <a class="social-media-imgs" href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
          <img src="./assets/images/account_type/Facebook App Symbol.svg" alt="f" width="15px" height="15px">
        </a>

        <a class="social-media-imgs" href="https://x.com/Medworld_Expo" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Twitter.svg" alt="f" width="15px" height="15px"></a>
        <a class="social-media-imgs" href="https://www.youtube.com/@MedworldExpo" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Youtube.svg" alt="f" width="15px" height="15px"></a>
        <a class="social-media-imgs" href="https://www.linkedin.com/company/medworld-expo/" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Linkedin Big Logo.svg" alt="f" width="15px" height="15px"></a>
        <a class="social-media-imgs" href="https://www.instagram.com/medworld_expo/" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Instagram.svg" alt="InstagramImg" width="15px" height="15px"></a>
      </div>
    </div>
  </div>
</div>
  <div class="parent-container">
    <div class="filter">
      <app-brand-product-filter [filterColumns]="['Products' , 'Region']" [data]="originalData"  [heading]="'Explore Exhibitions'" [brandProfileProducts]="brandProfileProducts"   (filteredData)="onFilteredData($event)"></app-brand-product-filter>
    </div>

    <div class="product-list">
      <div *ngIf="paginatedItems?.length === 0"  class="no-results">
        <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
        <div class="no-records-found"> No Exhibitions Found </div>
      </div>
      <div class="card" *ngFor="let product of paginatedItems">
        <div class="cardImage" >
        <img height="150" class="card-image1" [src]="product.files[0]" alt="{{ product?.title }}">
      </div>
        <div class="card-content">
          <h2>{{ product?.title }}</h2>
          <hr/>
          <ul class="card-info">
            <li>
              <span class="icon"><img src="../../../assets/images/icons/calender-icon.svg" alt="address"/></span>
              {{ product?.exhibitionStartDate }} - {{ product?.exhibitionEndDate }}
            </li>
          </ul>
          <div class="description-container">
            <p>{{product?.showMore ? product?.description : (product?.description | slice:0:50) + '...'}}</p>
            <a *ngIf="product?.description && product.description.length > 100" (click)="toggleShowMore(product)">
              {{product?.showMore ? 'Show less' : 'Read more'}}
            </a>
          </div>
        </div>
  
          <button 
            type="button" 
            [disabled]="isExhibitionClosed(product)"
            [ngClass]="{ 'disabled-button': isExhibitionClosed(product), 'active-button': !isExhibitionClosed(product) }" 
            (click)="openDialog(product)">
            {{ isExhibitionClosed(product) ? 'Closed' : 'Book An Appointment' }}
          </button>
      </div>
    </div>
  </div>
  <div class="pagination-container">
    <span class="exihibitionPagination" >
      <app-pagination [itemsPerPage]="itemsPerPage" [data]="products" (pageChanged)="onPageChanged($event)" ></app-pagination>
      <p class="exhibitionsTotalEntries">Total Results: {{products.length}} </p>
    </span>
  </div>
